import {TeamI18n} from '@/locales/base.message.locales';

export const team: TeamI18n = {
  dialog: {
    destroy_team: 'Remover time',
    sure_to_destroy: 'Você tem certeza que deseja remover esse time?',
  },
  tooltip: {
    destroy: 'Apagar time',
    invite: 'Convidar',
    edit: 'Editar time'
  },
  messages: {
    exit: {
      failed: 'Falhou ao sair do time',
      success: 'Você saiu do time'
    },
    create: {
      failed: 'Falhou ao criar o time',
      success: 'Time criado com sucesso',
    },
    destroy: {
      failed: 'Falhou ao remover o time',
      success: 'Time removido com sucesso',
    }, edit: {
      failed: 'Falhou ao editar o time',
      success: 'Time editado com sucesso',
    }
  },
  title: 'Time | Times',
  invitations: 'Convite de Times',
  actions: {
    create: 'Criar Time',
    destroy: 'Remover Time',
    edit: 'Editar Time',
    invite: 'Enviar Convite | Enviar Convites',
    invite_users: 'Convidar usuários',
    request_participation: 'Solicitar participação',
    exit: 'Sair do time',
    cancel_invite: 'Cancelar Convite',
  },
  buttons: {
    members: 'Membros',
    pendent_invitations: 'Convites Pendentes',
    search: 'Buscar',
  },
  labels: {
    full_members: '{members} Membros',
    open_member_slots: '{members} Membros - {slots} vagas',
    leader: 'Capitão',
    name: 'Nome do time',
    banner_input: 'Imagem de banner do time',
    country_filter_title: 'Filtrar por país',
    members_subtitle: 'Use os filtros para encontrar as pessoas ideais para o seu time.',
    skills_filter_title: 'Filtrar por habilidades',
    countr_filter_select: 'Selecionar país',
    select_users: 'Selecione os usuários para convidar para o seu time',
    users_empty: 'Nenhum usuário encontrado para convidar',
    search_users: 'Buscar participantes para meu time',
  },
  invites: {
    empty: 'Você nao tem nenhum convite para tive com o filtro selecionado',
    text: 'Nessa seção serão exibidos todos os convites de times que você recebeu e/ou enviou. para enviar um convite a algum time, primeiramentoe você deve estar participando de um desafio, então escolher um dos times existentes e enviar uma solicitação para fazer parte do time',
    messages: {
      invited: {
        accepted: 'Convite aceito',
        pending: 'Convite aguardando resposta',
        rejected: 'Convite recusado',
        canceled: 'Convite cancelado',
        removed: 'Convite removido'
      },
      requested: {
        accepted: 'Solicitação aprovada',
        pending: 'Solicitação aguardando resposta',
        rejected: 'Solicitação recusada',
        canceled: 'Solicitação cancelada',
        removed: 'Solicitação removida'
      }
    },
    challenge_name: 'Desafio: {name}',
    filter: {
      mode: 'Tipo',
      status: 'Status'
    },
    mode: {
      invited: 'Recebido',
      requested: 'Enviado'
    },
    status: {
      accepted: 'Aceito',
      pending: 'Pendente',
      rejected: 'Recusado',
      canceled: 'Cancelado',
      removed: 'Removido'
    }
  }
};
